import React from 'react';
import { Switch } from 'react-router-dom';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import OverView from './overview';
import AdminOverView from './overview/AdminOverview';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId`} component={OverView} />
      <ErrorBoundaryRoute path={match.url} component={AdminOverView} />
    </Switch>
  </>
);
export default Routes;
